import React, {useState} from 'react';
import Page from "../../components/Page";
import useInputs from "../../hooks/useInputs";
import GenericInputLayout from "../../layouts/GenericInput/GenericInputLayout";
import ItemUtils from "../../utils/ItemUtils";
import {CreateCourse, DeleteCourse, GetCourses, UpdateCourse} from "../../api/CourseApi";
import {useSnackbar} from "notistack";
import {CourseInputs} from "./CourseInputs";

export default function CoursePage() {
  const [items, setItems] = useState([]);
  const inputs = useInputs(CourseInputs);
  const {enqueueSnackbar} = useSnackbar();

  const populate = () => {
    GetCourses().then(json => {
      setItems(json);
    })
  }

  React.useEffect(() => {
    populate();
  }, []);

  const handleDelete = (e, item) => {
    return DeleteCourse(item.id).then(() => {
      setItems(ItemUtils.removeItem(items, item));
      enqueueSnackbar(`Successfully deleted course: ${item.name}`, {variant: 'success'});
    });
  }

  const handleEdit = async (values) => {
    return UpdateCourse(values.id, values).then(json => {
      setItems(ItemUtils.replaceItem(items, json));
    });
  }

  return (
      <Page title="Courses" sx={{ position: 'relative'}}>
        <GenericInputLayout
            header="Courses"
            newHeader="Add Course"
            inputs={inputs}
            items={items}
            filterBy={'name'}
            createAction={CreateCourse}
            onCreate={populate}
            onEdit={handleEdit}
            onDelete={handleDelete}
            getDisplayName={item => item.name}
        />
      </Page>
  )
}